import { useOnboardingTimeTracker } from '@/hooks/useOnboardingTimeTracker';

export function OnboardingTimeTracker() {
  useOnboardingTimeTracker({ thresholdMinutes: 10 });
  return null;
}
